@use '@design/design-tokens/typography/typography' as *;

.root {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.titleBase {
  @include typography-v2-title-base;
}

.bodySmall {
  @include typography-v2-body-sm;
}

.sectionRow {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.verticalDivider {
  width: 1px;
  height: 48px;
  background-color: var(--border-soft);
}

.styledRankWrapper {
  @include typography-v2-body-sm;
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.rankContainer {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.rankLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.rankFlexRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
}
